// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__xz675","selected":"Chip_selected__wTLap"};